<template>
  <div>
    <v-card>
      <v-card-title class="headline">Подгрузка тезисов
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12" lg="6">
            <v-card class="pa-4">
              <v-row>
                <v-col>
                  <v-textarea
                    :maxlength="250"
                    counter
                    outlined
                    rows="3"
                    v-model="thesis.name"
                    label="Название доклада"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="5" class="pt-0 pb-0">
                  <v-text-field
                    v-model="thesis.author.fio"
                    label="Докладчик"
                    required>
                  </v-text-field>
                </v-col>
                <v-col cols="7" class="pt-0 pb-0">
                  <v-text-field
                    v-model="thesis.author.org"
                    label="Организация"
                    v-on:keyup="recalc_authors()"
                    required>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="5" class="pt-2 pb-0">
                </v-col>
                <v-col cols="7" class="pt-0 pb-0">
                  <v-text-field
                    v-model="thesis.email"
                    label="E-mail"
                    required>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row v-for="ca in thesis.coautors" :key="ca.id">
                <v-col cols="5" class="pt-0 pb-0">
                  <v-text-field
                    v-model="ca.fio"
                    label="Соавтор"
                    required>
                  </v-text-field>
                </v-col>
                <v-col cols="7" class="pt-0 pb-0">
                  <v-text-field
                    v-model="ca.org"
                    label="Организация"
                    v-on:keyup="recalc_authors()"
                    required>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4"></v-col>
                <v-col cols="8">
                  <v-btn color="green" 

                    @click="add_coautor()">{{"добавить соавтора"}}
                  </v-btn>
                </v-col>
              </v-row>

              <v-row style="margin-bottom: -20px !important;">
                <v-col>
                  <v-textarea
                    outlined
                    :maxlength="3500"
                    counter
                    rows="8"
                    v-model="thesis.text"
                    label="Тезисы *"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row style="margin-left: 12px !important; margin-top: 0px !important;">
                <p> *для выделения текста курсивом используйте тег: &lt;i&gt;<i style="font-style: italic;">текст курсивом</i>&lt;/i&gt; </p>
              </v-row>

              <v-row>
                <v-col>
                  <v-textarea
                    outlined
                    counter
                    :maxlength="400"
                    rows="3"
                    v-model="thesis.finance"
                    label="Финансовая поддержка"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row v-for="lit_descr, id in thesis.lit" :key="id">
                <v-col cols="12" class="pt-0 pb-0">
                  <v-text-field
                    v-model="thesis.lit[id]"
                    label="Литература"
                    required>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="thesis.lit.length < 5">
                <v-col cols="5" class="pt-2 pb-0">
                  <v-btn color="green darken-1"
                    @click="add_lit()">{{"добавить"}}
                  </v-btn>
                </v-col>
              </v-row>

            </v-card>

          </v-col>
          <v-col cols="12" lg="6">
            <v-card>
              <v-card-text style="text-align: center; font-size: 16px;">
                <b>{{ thesis.name }}</b>
              </v-card-text>
              <v-card-text style="text-align: center; font-size: 16px;">
                <u><b>{{ thesis.author.fio }}</b></u><sup><b> {{ (thesis.author.org_id + 1).toString() }}</b></sup>
                <b v-for="co in thesis.coautors">, {{ co.fio }}<sup><b>{{ (co.org_id + 1).toString() }}</b></sup></b>
              </v-card-text>
              <v-card-text class="pa-0" v-for="org, id in author_orgs" style="text-align: center; font-size: 14px;" :key="id">
                <p style="font-style: italic;"><sup>{{ (id + 1).toString() }}</sup>{{ org }}<i v-if="id == 0"  style="font-style: italic;">, {{ thesis.email }}</i></p>
              </v-card-text>

              <v-card-text v-html="view_thesis" style="text-indent: 20px; text-align: justify;"></v-card-text>
              <!-- <p>
                {{ view_thesis }}
              </p> -->
              <v-card-text  style="text-indent: 20px; text-align: justify;">
                {{ thesis.finance }}
              </v-card-text>

              <v-card-text style="text-align: center; font-size: 16px;" class="pb-0">
                <b>Литература</b>
              </v-card-text>
              <v-card-text class="pa-0" v-for="lit_descr,id in thesis.lit" :key="id" style="text-indent: 20px; text-align: justify;font-size: 12px;">
                <p v-if="lit_descr.length > 0" class="mb-0">{{ (id+1).toString() }}. {{ lit_descr }}</p>            
              </v-card-text>
           
              <v-card-text>
                <p></p>
              </v-card-text>

            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="clear_data(); $emit('updateParent', -1)">отмена</v-btn>
        <v-btn color="green darken-1" text
          @click="upload_thesis()">{{"Загрузить"}}
        </v-btn>
      </v-card-actions>

    </v-card>
  </div>
</template>
<script>
// import { validationMixin } from 'vuelidate';
// import { required, maxLength, email } from 'vuelidate/lib/validators';
import { mapActions, mapGetters, mapMutations } from 'vuex';
// import { parserDate, parserString } from '../../helpers/parserDate';
// import { AUTH_URL, REFERENCES_URL, USER_URL } from '../../../vars';
// import user from '../../assets/user.png';

export default {
  mounted() {
    // this.uploadDataUser();
  },
  name: 'ThesisUpload',

  props: {
    current_user_registration_id: Number
  },

  data: () => ({
    loading: false,
    thesis: {
      name: '',
      text: '',
      finance: '',
      email: '',
      lit: [''],
      coautors: [],
      author: {
        fio: '', 
        org: '', 
        id: 0,
        org_id: 0
      }
    },
    author_orgs: [],
    orgs_count: 1,
    authors_count: 1,
    view_thesis: '',
  }),

  components: {
  },

  watch: {
    'thesis.name'(val){
      this.thesis.name = val.toUpperCase()
    },

    'thesis.text'(val){
      var t = this.thesis.text.replaceAll('<i>','<i style="font-style: italic;">')
      // console.log('thesis.text', t)
      this.view_thesis = '<p style="margin-bottom: 0px">' +  t.replace(/\n/g,'</p><p style="margin-bottom: 0px">') + '</p>'
    },
  },

  computed: {
    ...mapGetters([
    ]),
  },

  created() {
  },

  methods: {
    ...mapActions([
      'UPLOAD_THESIS',
    ]),
    ...mapMutations([
      'UPDATE_OVERLAY',
    ]),

    add_lit(){
      if(this.thesis.lit.length < 5)
        this.thesis.lit.push('')
    },

    clear_data(){
      this.thesis= {
        name: '',
        text: '',
        finance: '',
        email: '',
        lit: [''],
        coautors: [],
        author: {
          fio: '', 
          org: '', 
          id: 0,
          org_id: 0
        }
      }
      this.author_orgs = []
      this.orgs_count = 1
      this.authors_count = 1
      this.view_thesis = ''

    },

    upload_thesis(){
      this.UPDATE_OVERLAY(true)
      var data = {
        current_user_registration_id: this.current_user_registration_id,
        thesis: this.thesis
      }

      console.log('upload_thesis', data)
      this.UPLOAD_THESIS(data)
        .then((res) => {
          if (!res.data.hasOwnProperty('error')) {

            this.clear_data()
            this.$emit('updateParent', 1)

            this.$messageHelper('Тезисы успешно загружены', 'success', 3000);
          } else {
            this.$messageHelper(res.data.error, 'error', 3000);
          }
          this.UPDATE_OVERLAY(false)
        })
        .catch((e) => {
          console.log('eee', e);
          this.$messageHelper(e.message, 'error', 4000);
          this.UPDATE_OVERLAY(false)
        });

    },

    add_coautor(){
      this.thesis.coautors.push({fio: '', org: '', id: this.authors_count, org_id: 0})
      this.recalc_authors()
      this.authors_count += 1
    },

    recalc_authors(){
      var found = -1
      this.author_orgs = []
      this.author_orgs.push(this.thesis.author.org)
      this.thesis.coautors.forEach((item) => {
        found = -1
        if(item.org.length > 0){
          this.author_orgs.forEach((jtem, count) => {
            if(item.org == jtem)
              found = count
          })
          if(found > -1){
            item.org_id = found
          }
          else{
            this.author_orgs.push(item.org)
            item.org_id = this.author_orgs.length - 1
          }
        }
      })
      // console.log('recalc_authors_2', this.author_orgs)
      // console.log('recalc_authors_2', this.thesis)
    },
  }

};
</script>
